import React from 'react'
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { max, min, values, keys } from 'lodash'
import { geoMercator, geoPath } from "d3-geo"
import { feature } from "topojson-client"
import { scaleLinear } from "d3-scale"
import { setSelectedCountry, setComparisonCountry } from '../../state/actions'
import BubbleAndBarChart from '../BubbleAndBarChart'
import { Origin } from 'redux-tooltip';
import { saveSvgAsPng } from 'save-svg-as-png'
import { getCsvFile } from '../../utils/csvdownload'
import './index.css'


const worldData = require ("./110m.json")
const worldFeatures = feature(worldData, worldData.objects.countries).features
const Gpath = Origin.wrapBy('path');


class MapChart extends React.PureComponent {

  projection() {
    const { height=300 } = this.props
    return geoMercator()
      .scale(100)
      .translate([ 800 / 2, height / 2 ])
  }

  getFillOpacity(d, scale){
    const { emptyFill, dataMap } = this.props
    if(dataMap[d.id]){
      const out = scale(dataMap[d.id])
      return out
    }
    return emptyFill ? 1 : 0
  }

  getFill(d, scale){
    const { dataMap, fill="#0D66A5", emptyFill } = this.props
    if(dataMap[d.id] !== undefined){
      return fill
    }
    return  emptyFill || 'transparent'
  }

  handleSelectCountry = (countryCode) => (e) => {
    if(!this.props.topic || this.props.interactive===false){
      return
    }
    this.props.setSelectedCountry(countryCode)
    if(countryCode === null){
        this.props.setComparisonCountry(null)
    }
  }

  downloadPng = (e) => {
    const { topic } = this.props
    var node = ReactDOM.findDOMNode(this).querySelector('svg')
    const dk = node.querySelector(".download-links");
    dk.classList.add("hide")
    saveSvgAsPng(node, `${topic ? topic+"-" : '' }MAP.png`, { backgroundColor: '#fff'})
    dk.classList.remove("hide")
  }

  downloadCsv =  (e) => {
    const { countries, topic, tfa=false } = this.props
    return tfa
    ? getCsvFile(`${topic}.csv`, keys(countries).sort(), [], [topic])
    : getCsvFile(`${topic}.csv`, keys(countries).sort(), [topic])
  }

  getTooltipContent = (d) => {
    const { countries, topic, dataMap, tfa=false } = this.props
    if(tfa){
        return countries[d.id]
        ? `${countries[d.id]} ${ topic ? ": " + (dataMap[d.id] || "no data") : '' }`
        : 'no data'
    }
    return countries[d.id] ? `${countries[d.id]} ${topic ? ": " + (dataMap[d.id] || "no data") : ''}` : 'no data'
  }

  render() {
    const { latestDataByIndicator,
      height, dataMap, stroke="#0D66A5", borderColor='#0D66A5',
      maxScale, minScale, decreasing=false,
      selectedCountry, comparisonCountry,
      showDownloads=false } = this.props

    const dataValues = values(dataMap)
    const margin = 10
    let maxValue = maxScale || max(dataValues)
    // # TODO: should we use minValue?
    // let minValue = minScale || min(dataValues)
    const scale = scaleLinear().domain([0, maxValue]).range(decreasing ? [1, 0] : [0, 1])

    return (
      <div style={{ position:'relative' }}>

        {(selectedCountry !== null) && (

          <div className="MapChart__chart_container" onClick={this.handleSelectCountry(null)}>
            <div className="MapChart__overlay border-blue">
              <div className={`${ comparisonCountry ? 'MapChart__overlay__box--double' : 'MapChart__overlay__box' }`}
                onClick={(e)=> { e.stopPropagation()}}>
                <BubbleAndBarChart latestDataByIndicator={latestDataByIndicator} countryCode={selectedCountry}/>
              </div>
              {(comparisonCountry !== null) && (
                <div className="MapChart__overlay__box--double" onClick={(e)=> { e.stopPropagation()}}>
                  <BubbleAndBarChart latestDataByIndicator={latestDataByIndicator} countryCode={comparisonCountry}/>
                </div>
              )}
            </div>
          </div>
        )}

      <svg className="MapChart__svg" style={{borderColor:borderColor}} height={height} width="100%" viewBox={`0 0 ${800} ${height}`}>
        {/* the map!! */}
        <g>
          {
            worldFeatures.map((d,i) => (

              <Gpath
                key={ `path-${ i }` }
                content={this.getTooltipContent(d)}
                d={ geoPath().projection(this.projection())(d) }
                className="country"
                onClick={ this.handleSelectCountry(d.id) }
                fill={this.getFill(d)}
                fillOpacity={ this.getFillOpacity(d, scale) }
                stroke={stroke}
                strokeOpacity={0.2}
                strokeWidth={ 0.5 }
              />
            ))
          }
        </g>

        { showDownloads && (
          <g className="download-links" transform={`translate(${0}, ${margin})`}>
          <text y={margin/2} className="MapChart__download_title">DOWNLOAD</text>
          <text y={margin/2 + 20}>
            <tspan className="MapChart__download_label pointer" onClick={this.downloadCsv}>CSV</tspan>
            <tspan>&nbsp;&nbsp;</tspan>
            <tspan className="MapChart__download_label pointer" onClick={this.downloadPng}>VIZ</tspan>
          </text>
          </g>
        )}
      </svg>
    </div>
    )
  }
}


const mapStateToProps = (state, props) => ({
  countries: state.countries,
  selectedCountry: state.selectedCountry,
  comparisonCountry: state.comparisonCountry,
})

const mapDispatchToProps = { setSelectedCountry, setComparisonCountry }

export default connect(mapStateToProps, mapDispatchToProps)(MapChart)



// WEBPACK FOOTER //
// ./src/components/MapChart/index.js